import { PURGE } from 'redux-persist';

const initialState = {
  activeJobs: [], // [{ jobId, type, label, total, progress, status }]
};

const Jobs = (state = initialState, { type, payload }) => {
  switch (type) {
    case PURGE:
      return initialState;

    case 'JOB_ADD':
      // Reason: `job:active` is re-emitted on every socket register, so the same job must not produce a second card.
      if (state.activeJobs.some(j => j.jobId === payload.jobId)) return state;
      return { ...state, activeJobs: [...state.activeJobs, { jobId: payload.jobId, type: payload.type, total: payload.total, meta: payload.meta || {}, progress: 0, status: 'running' }] };

    case 'JOB_PROGRESS':
      // Reason: keep processed/total alongside the % so the details dialog can render live counts from the same source as the panel.
      return { ...state, activeJobs: state.activeJobs.map(j => j.jobId === payload.jobId ? { ...j, progress: payload.progress, processed: payload.processed ?? j.processed, total: payload.total ?? j.total } : j) };

    case 'JOB_COMPLETED':
      return { ...state, activeJobs: state.activeJobs.map(j => j.jobId === payload.jobId ? { ...j, progress: 100, status: 'completed' } : j) };

    case 'JOB_FAILED':
      return { ...state, activeJobs: state.activeJobs.map(j => j.jobId === payload.jobId ? { ...j, status: 'failed', error: payload.error } : j) };

    case 'JOB_CANCELLED':
      return { ...state, activeJobs: state.activeJobs.map(j => j.jobId === payload.jobId ? { ...j, status: 'cancelled' } : j) };

    case 'JOB_STATUS': {
      const { jobId, ...rest } = payload;
      return { ...state, activeJobs: state.activeJobs.map(j => j.jobId === jobId ? { ...j, ...rest } : j) };
    }

    case 'JOB_DISMISS':
      return { ...state, activeJobs: state.activeJobs.filter(j => j.jobId !== payload.jobId) };

    default:
      return state;
  }
};

export default Jobs;
